export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/notes-icon.svg?4dd3c9de2b63bbe42664f7d78570473a";